import { orderService } from "@/services/api/order.service";
import { orderModel } from "@/models/api/order.model";
import { sharedHelper, alertHelper } from "@/utils";
import i18n from "@/i18n";

export const ORDER_MODULE = "api/order";
export const GET_ALL_ORDER = "getAllOrder";
export const CREATE_ORDER = "createOrder";
export const GET_ORDER = "getOrder";
export const UPDATE_ORDER = "updateOrder";
export const DELETE_ORDER = "deleteOrder";

export const state = {
  list: {
    data: [],
    pagination: {
      pageNumber: 1,
      pageSize: 15,
      lastPage: 1,
      tableRowsCounts: 0,
      total: 0,
    },
  },
  details: {},
  listError: false,
  status: {
    list: true,
    detail: true,
    save: true,
  },
};

function showError(commit, error, type = "save") {
  commit("failure", type);
  alertHelper.alertError({
    message: sharedHelper.getErrorMessage(error),
    title: i18n.t("message.error"),
  });
}

function requireSuccess(result) {
  if (!result?.success)
    throw new Error(result?.message || "Order request failed.");
  return result;
}

async function refresh(dispatch, filter) {
  await dispatch(GET_ALL_ORDER, { filter });
}

export const actions = {
  async [GET_ALL_ORDER]({ commit }, { filter }) {
    commit("requesting");
    try {
      const result = await orderService.getAll(filter);
      requireSuccess(result);
      commit("listSuccess", result);
      return result;
    } catch (error) {
      showError(commit, error, "list");
      return null;
    }
  },
  async [CREATE_ORDER]({ commit, dispatch }, { data, filter }) {
    commit("requesting", "save");
    try {
      const result = await orderService.store(data);
      requireSuccess(result);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.createXSuccess", [i18n.t("module.order")]),
      });
      await refresh(dispatch, filter);
      return result;
    } catch (error) {
      showError(commit, error);
      return null;
    }
  },
  async [GET_ORDER]({ commit }, { uuid }) {
    commit("requesting", "detail");
    try {
      const result = await orderService.show(uuid);
      requireSuccess(result);
      commit("detailSuccess", result);
      return result;
    } catch (error) {
      showError(commit, error);
      return null;
    }
  },
  async [UPDATE_ORDER]({ commit, dispatch }, { data, filter }) {
    commit("requesting", "save");
    try {
      const result = await orderService.update(data);
      requireSuccess(result);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.updateXSuccess", [i18n.t("module.order")]),
      });
      await refresh(dispatch, filter);
      return result;
    } catch (error) {
      showError(commit, error);
      return null;
    }
  },
  async [DELETE_ORDER]({ commit, dispatch }, { uuid, filter }) {
    commit("requesting", "save");
    try {
      const result = await orderService.softDelete(uuid);
      requireSuccess(result);
      commit("success");
      alertHelper.alertSuccess({
        message: i18n.t("message.deleteXSuccess", [i18n.t("module.order")]),
      });
      await refresh(dispatch, filter);
      return result;
    } catch (error) {
      showError(commit, error);
      return null;
    }
  },
};

export const mutations = {
  requesting(state, type = "list") {
    state.status[type] = false;
    if (type === "list") state.listError = false;
  },
  listSuccess(state, result) {
    state.list.data = (result?.data || []).map(orderModel);
    state.list.pagination = sharedHelper.apiPaginationAdapter(
      result?.pagination || {},
    );
    state.status.list = true;
  },
  detailSuccess(state, result) {
    const payload = result?.data?.order || result?.data || {};
    state.details = orderModel(payload);
    state.status.detail = true;
  },
  success(state) {
    state.status = {
      list: true,
      detail: true,
      save: true,
    };
  },
  failure(state, type) {
    if (type === "list") state.listError = true;
    state.status = {
      list: true,
      detail: true,
      save: true,
    };
  },
};
